import { connect } from 'react-redux';
import OnboardingProcessPage from 'pages/OnboardingProcessPage';
import onboardingActions from 'store/onboarding/actions';

const mapStateToProps = state => {
  return {
    stepsData: state.onboarding.stepsData,
    isLoadingSteps: state.onboarding.isLoadingSteps,
  };
};
const mapDispatchToProps = {
  loadOnboardingSteps: onboardingActions.Creators.loadOnboardingStepsRequest,
  submitOnboardingSteps: onboardingActions.Creators.submitOnboardingResponseRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingProcessPage);
